export function hotseatPlayerId(index) {
    return `u-hotseat-${index}`;
}
export function isHotseatPlayerId(playerId) {
    return playerId.startsWith('u-hotseat-');
}
export function hotseatPlayerIndex(playerId) {
    if (!isHotseatPlayerId(playerId)) {
        throw new Error(`Invalid hotseat player ID: ${playerId}`);
    }
    return parseInt(playerId.split('-')[2], 10);
}
//# sourceMappingURL=hotseat.js.map